export default __webpack_public_path__ + "static/media/home-banner1.ddc968e2.png";